module.exports = __webpack_public_path__ + "img/broccThumb.686f71c7.jpeg";